// Subset of ISO-3166-1 alpha-2 (top trade markets). Replace with `i18n-iso-countries`
// or backend-served list once full coverage is required.
export interface Country {
  code: string;
  nameEn: string;
}

export const COUNTRIES: Country[] = [
  { code: 'AE', nameEn: 'United Arab Emirates' },
  { code: 'AM', nameEn: 'Armenia' },
  { code: 'AR', nameEn: 'Argentina' },
  { code: 'AT', nameEn: 'Austria' },
  { code: 'AU', nameEn: 'Australia' },
  { code: 'AZ', nameEn: 'Azerbaijan' },
  { code: 'BE', nameEn: 'Belgium' },
  { code: 'BG', nameEn: 'Bulgaria' },
  { code: 'BR', nameEn: 'Brazil' },
  { code: 'BY', nameEn: 'Belarus' },
  { code: 'CA', nameEn: 'Canada' },
  { code: 'CH', nameEn: 'Switzerland' },
  { code: 'CL', nameEn: 'Chile' },
  { code: 'CN', nameEn: 'China' },
  { code: 'CZ', nameEn: 'Czechia' },
  { code: 'DE', nameEn: 'Germany' },
  { code: 'DK', nameEn: 'Denmark' },
  { code: 'EG', nameEn: 'Egypt' },
  { code: 'ES', nameEn: 'Spain' },
  { code: 'FI', nameEn: 'Finland' },
  { code: 'FR', nameEn: 'France' },
  { code: 'GB', nameEn: 'United Kingdom' },
  { code: 'GE', nameEn: 'Georgia' },
  { code: 'GR', nameEn: 'Greece' },
  { code: 'HK', nameEn: 'Hong Kong' },
  { code: 'HU', nameEn: 'Hungary' },
  { code: 'ID', nameEn: 'Indonesia' },
  { code: 'IE', nameEn: 'Ireland' },
  { code: 'IL', nameEn: 'Israel' },
  { code: 'IN', nameEn: 'India' },
  { code: 'IR', nameEn: 'Iran' },
  { code: 'IT', nameEn: 'Italy' },
  { code: 'JP', nameEn: 'Japan' },
  { code: 'KG', nameEn: 'Kyrgyzstan' },
  { code: 'KR', nameEn: 'Korea, Republic of' },
  { code: 'KZ', nameEn: 'Kazakhstan' },
  { code: 'MA', nameEn: 'Morocco' },
  { code: 'MX', nameEn: 'Mexico' },
  { code: 'MY', nameEn: 'Malaysia' },
  { code: 'NL', nameEn: 'Netherlands' },
  { code: 'NO', nameEn: 'Norway' },
  { code: 'NZ', nameEn: 'New Zealand' },
  { code: 'PH', nameEn: 'Philippines' },
  { code: 'PL', nameEn: 'Poland' },
  { code: 'PT', nameEn: 'Portugal' },
  { code: 'RO', nameEn: 'Romania' },
  { code: 'RS', nameEn: 'Serbia' },
  { code: 'RU', nameEn: 'Russian Federation' },
  { code: 'SA', nameEn: 'Saudi Arabia' },
  { code: 'SE', nameEn: 'Sweden' },
  { code: 'SG', nameEn: 'Singapore' },
  { code: 'TH', nameEn: 'Thailand' },
  { code: 'TJ', nameEn: 'Tajikistan' },
  { code: 'TM', nameEn: 'Turkmenistan' },
  { code: 'TR', nameEn: 'Türkiye' },
  { code: 'TW', nameEn: 'Taiwan' },
  { code: 'UA', nameEn: 'Ukraine' },
  { code: 'US', nameEn: 'United States' },
  { code: 'UZ', nameEn: 'Uzbekistan' },
  { code: 'VN', nameEn: 'Viet Nam' },
  { code: 'ZA', nameEn: 'South Africa' },
];
